const KEY = 'dofarm_announcement_dismissed' // localStorage: JSON array of permanently-dismissed announcement ids

// Accepts the legacy `{ [id]: 'yyyy-MM-dd' }` shape (from before dismissal
// became permanent instead of same-day-only) by reading just its keys,
// alongside the current array shape.
const readIds = (): string[] => {
  try {
    const raw = localStorage.getItem(KEY)
    if (!raw) return []
    const parsed = JSON.parse(raw)
    if (Array.isArray(parsed)) {
      return parsed.map(String)
    }
    if (parsed && typeof parsed === 'object') {
      return Object.keys(parsed)
    }
    return []
  } catch {
    return []
  }
}

const writeIds = (ids: string[]): void => {
  try {
    localStorage.setItem(KEY, JSON.stringify(ids))
  } catch {
    // storage failures must never break the page
  }
}

// All localStorage access in try/catch — storage failures must never break the page.
export const getDismissedIds = (): Set<string> => {
  try {
    return new Set(readIds())
  } catch {
    return new Set()
  }
}

export const markDismissed = (id: string): void => {
  try {
    const ids = new Set(readIds())
    ids.add(id)
    writeIds(Array.from(ids))
  } catch {
    // storage failures must never break the page
  }
}
